import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject, Observable, Subscription, throwError } from 'rxjs';
import { catchError, finalize, map, retry } from 'rxjs/operators';
import { ServiceHttpBase } from './service-http-base.service'
import { MemberModel } from '../models/member.model';
import { CardModel } from '../models/card.model';
import {FarmModel } from '../models/farm.model';
import { CardHistoryModel } from '../models/cardhistory.model';
import { FarmWorkerModel } from '../models/farmworker.model';
import { FarmWorkerDataModel } from '../models/farmworkerdata.model';
import { OtherAidModel } from '../models/otheraid.model';
import { RRIMNiagaModel } from '../models/rrimniaga.model';
import { environment } from 'src/environments/environment';
import { CurrentMemberHttpService } from './api/current-member-http.service';

@Injectable({
  providedIn: 'root'
})
export class CurrentMemberService  {
  public baseURL=`${environment.apiUrl}`;
  configUrl = this.baseURL + '/CurrentMember/GetInfo';
  getInfoByUsernameUrl = this.baseURL + '/CurrentMember/GetInfoByUsername';
  getCardsURL = this.baseURL + '/CurrentMember/GetCards';
  getCardsActiveURL = this.baseURL + '/CurrentMember/GetCardsActive';
  getCardsInActiveURL = this.baseURL + '/CurrentMember/GetCardsInactive';
  getCardsCancelledURL = this.baseURL + '/CurrentMember/GetCardsCancelled';
  getCardHistoriesURL = this.baseURL + '/CurrentMember/GetCardHistories';
  getFarmsOwnedURL = this.baseURL + '/CurrentMember/GetFarmsOwned';
  getFarmsWorkURL = this.baseURL + '/CurrentMember/GetFarmsWork';
  //configUrl = this.baseURL + '/Member/GetMemberInfo?memberId=492888';
  getFarmsWorkersURL = this.baseURL + '/CurrentMember/GetFarmsWorkers';
  getFarmsInProcessURL = this.baseURL + '/CurrentMember/GetFarmsInProcess';
  getFarmsWorkersDataURL = this.baseURL + '/CurrentMember/GetFarmsWorkersData';
  getIpgsURL = this.baseURL + '/CurrentMember/GetIpgs';
  getIplsURL = this.baseURL + '/CurrentMember/GetIpls';
  getAgreementsURL = this.baseURL + '/CurrentMember/GetAgreements';
  getOtherAidURL = this.baseURL + '/CurrentMember/GetOtherAids';
  getRRIMNiagaURL = this.baseURL + '/CurrentMember/GetRRIMNiaga';
  getFarmsInActiveProcessURL = this.baseURL + '/CurrentMember/GetFarmsInActiveProcess';
  private unsubscribe: Subscription[] = [];
  isLoading$: Observable<boolean>;
  isLoadingSubject: BehaviorSubject<boolean>;

  constructor(private http: HttpClient,
    private currentMemberHttpService: CurrentMemberHttpService) {
      this.isLoadingSubject = new BehaviorSubject<boolean>(false);
      this.isLoading$ = this.isLoadingSubject.asObservable();
    //super();
  }

  getInfo() {
   // console.log(this.configUrl);
    var member=this.http.get<MemberModel>(this.configUrl);
    return member;
  }

  getInfoByUsername() {
    console.log(this.getInfoByUsernameUrl);
    var member=this.http.get<MemberModel>(this.getInfoByUsernameUrl);
    return member;
  }

  /**
   * Get all cards (active, inactive and cancelled)
   * @returns
   */
  getCards() {
   // console.log(this.getCardsURL);
    var member=this.http.get<CardModel[]>(this.getCardsURL);
    return member;
  }

  getCardsActive() {
   // console.log(this.getCardsActiveURL);
    var member=this.http.get<CardModel[]>(this.getCardsActiveURL);
    return member;
  }

  getCardsInActive() {
   // console.log(this.getCardsInActiveURL);
    var member=this.http.get<CardModel[]>(this.getCardsInActiveURL);
    return member;
  }

  getCardsCancelled() {
   // console.log(this.getCardsCancelledURL);
    var member=this.http.get<CardModel[]>(this.getCardsCancelledURL);
    return member;
  }

  getCardHistories() {
   // console.log(this.getCardHistoriesURL);
    var member=this.http.get<CardHistoryModel[]>(this.getCardHistoriesURL);
    return member;
  }

  getFarmsOwn() {
   // console.log(this.getFarmsOwnedURL);
    var farms=this.http.get<FarmModel[]>(this.getFarmsOwnedURL);
    return farms;
  }

  getFarmsWork() {
   // console.log(this.getFarmsWorkURL);
    var farms=this.http.get<FarmModel[]>(this.getFarmsWorkURL);
    return farms;
  }

  getFarmsWorkers() {
   // console.log(this.getFarmsWorkersURL);
    var farms=this.http.get<FarmWorkerModel[]>(this.getFarmsWorkersURL);
    return farms;
  }

  getFarmsWorkersData() {
   // console.log(this.getFarmsWorkersDataURL);
    var farms=this.http.get<FarmWorkerDataModel[]>(this.getFarmsWorkersDataURL);
    return farms;
  }

  getFarmsInProcess() {
   // console.log(this.getFarmsInProcessURL);
    var farms=this.http.get<FarmModel[]>(this.getFarmsInProcessURL);
    return farms;
  }

  getFarmsInActiveProcess() {
   // console.log(this.getFarmsInActiveProcessURL);
    var farms=this.http.get<FarmModel[]>(this.getFarmsInActiveProcessURL);
    return farms;
  }

  getIpgs() {
   // console.log(this.getIpgsURL);
    var farms=this.http.get<FarmModel[]>(this.getIpgsURL);
    return farms;
  }


  getIpls() {
     var farms=this.http.get<FarmModel[]>(this.getIplsURL);
     return farms;
  }

  getAgreements() {
   // console.log(this.getAgreementsURL);
    var farms=this.http.get<FarmModel[]>(this.getAgreementsURL);
    return farms;
  }

  getOtherAids() {
   // console.log(this.getOtherAidURL);
    var aids = this.http.get<OtherAidModel[]>(this.getOtherAidURL);
    return aids;
  }

  getRRIMNiaga() {
   // console.log(this.getRRIMNiagaURL);
    var aids = this.http.get<RRIMNiagaModel[]>(this.getRRIMNiagaURL);
    return aids;
  }

  updateMember(member: MemberModel) {
    // console.log(this.updateMemberURL);
    // var response = this.http.post<UpdateMemberResponseModel>(this.updateMemberURL, member);
    // return response;
    this.isLoadingSubject.next(true);
    return this.currentMemberHttpService.updateMember(member).pipe(
      map((result: any) => {

        return result;
      }),
      catchError((err) => {
        console.error('err', err);
        throw new Error('Ralat kemaskini pengguna');
      }),
      finalize(() => this.isLoadingSubject.next(false))
    );
  }

}
